import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "skpTunjanganKhusus";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const skpTunjanganKhususCreate =
  "Kepegawaian/SkpTunjanganKhusus/create/";
export const skpTunjanganKhususUpdate =
  "Kepegawaian/SkpTunjanganKhusus/update/";
export const skpTunjanganKhususList = "Kepegawaian/SkpTunjanganKhusus/list/";
export const masterWorkUnit = "Master/List/workUnit/";
export const listAtasan = "Kepegawaian/SkpTunjanganKhusus/listAtasan/";
export const exportExcel = "Kepegawaian/SkpTunjanganKhusus/exportExcel/";
export const employeeList = "Kepegawaian/SkpTunjanganKhusus/listEmployee/";
export const individualcriterialist = "Kepegawaian/SkpTunjanganKhusus/get_individualcritereia/";
export const skppernipCreate = "Kepegawaian/SkpTunjanganKhusus/createpernip/";
export const skpTunjanganKhususDetail = "Kepegawaian/SkpTunjanganKhusus/detail/";
export const checkSkp = "Kepegawaian/SkpTunjanganKhusus/checkskp/";
export const getposition = "Kepegawaian/SkpTunjanganKhusus/get_position/";
export const checkverification = "Kepegawaian/SkpTunjanganKhusus/check_verification/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
